import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisregulation/getpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisregulation/getdetail/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisregulation/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datevehicleInfoGrouptypelimit = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisregulation/vehicleofflineanalysisregulation/updatevehicleInfoGrouptypelimit/' + params.vehicleInfoGroupids + '/' + params.typelimit + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const datetypelimit = (params, urlParams) => {
  return axios.request({
    url: '/da/vehicleofflineanalysisregulation/vehicleofflineanalysisregulation/' + params.terminalNum + '/' + params.typelimit + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

